import React, { Component } from 'react';
import SliderFront from '../../components/SliderFront/SliderFront';
import ProductSlider from '../../components/ProductSlider/ProductSlider';
import { SearchQuery, SearchJurnal, SearchImprint, SearchIhsan, SearchInspirasi, SearchIdea, SearchSlider} from '../../api/index';
import queryString from 'query-string'
import { NavLink, Link} from 'react-router-dom';
import { useState } from 'react';
import { Modal } from 'reactstrap';



class FrontPage extends Component {
    constructor(props) {
        super(props)

        this.state = {   //menyimpan data API
            bestSeller: [],           
            mostwanted:[],
            newest:[],
            highestprice:[],
            lowestprice:[],
            diskon:[],
            newproduct:[],
            store: [],
           

            showModal: false,
            pendingLink: null
        }
    }

    //Buat click tombol digistore
    handleStoreClick = (link) => {
        this.setState({ showModal: true, pendingLink: link });
      };
      
      handleConfirmRedirect = () => {
        window.open(this.state.pendingLink, "_blank");
        this.setState({ showModal: false, pendingLink: null });
      };
      
      handleCloseModal = () => {
        this.setState({ showModal: false, pendingLink: null });
      };
      

    fetchProduct = (payload,sortby) => {  //bagaimana data diambil
        SearchQuery(payload).then(result => {           
            this.setState({
                [sortby]: result.result,                
            })
        });
    }

    fetchProductJurnal = (payload,sortby) => {
        SearchJurnal(payload).then(result => {           
            this.setState({
                [sortby]: result.result,                
            })
        });
    }

    fetchProductImprint = (payload, sortby) => {
        SearchImprint(payload).then(result => {
            this.setState({
                [sortby] : result.result
            })
        });
    }

    fetchProductIhsan = (payload, sortby) => {
        SearchIhsan(payload).then(result => {
            this.setState({
                [sortby] : result.result
            })
        });
    }

    fetchProductInspirasi = (payload, sortby) => {
        SearchInspirasi(payload).then(result => {
            this.setState({
                [sortby] : result.result
            })
        });
    }

    fetchProductIdea = (payload, sortby) => {
        SearchIdea(payload).then(result => {
            this.setState({
                [sortby] : result.result
            })
        });
    }

   fetchSliderData = (sortby, stateKey) => { 
    const content = { sortby: sortby }

    SearchSlider(content).then(result => {
        // Tambahkan pengecekan di sini
        if (result && result.result) { 
            this.setState({
                [stateKey]: result.result, 
            });
        } else {
            console.warn('Data slider kosong atau tidak valid.');
        }
    });
}

    doingSearch = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) {
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProduct(content,sortby);
    }

    doingSearchJurnal = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) {
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProductJurnal(content,sortby);
    }

    //Baca URL & route
    doingSearchImprint = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) { //masuk link kategori
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProductImprint(content,sortby); //panggil API lewat fetch produk
    }

    //Baca URL & route
    doingSearchIhsan = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) { //masuk link kategori
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProductIhsan(content,sortby); //panggil API lewat fetch produk
    }

    //Baca URL & route
    doingSearchInspirasi = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) { //masuk link kategori
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProductInspirasi(content,sortby); //panggil API lewat fetch produk
    }

    //Baca URL & route
    doingSearchIdea = (sortby) => {
        this.setState({ isFetching: true })
        const query = queryString.parse(this.props.location.search); // ?name=&category=&babibu=

        let byName = '';
        let byminPrice = '';
        let bymaxPrice = '';
        let byCategory = '';
        let bySort = sortby;
        let page = '';

        if (query.name !== undefined) { //masuk link kategori
            byName = query.name ? query.name : '';
            byminPrice = query.minprice ? query.minprice : '';
            bymaxPrice = query.maxprice ? query.maxprice : '';
            byCategory = query.category ? query.category : '';
            bySort = query.sortby ? query.sortby : '';
            page = query.page ? query.page : '';
            this.setState({ queryName: byName });
        }

        // jika klik dari menu
        if (this.props.match.params.nameCat !== undefined) {
            byCategory = this.props.match.params.nameCat
            page = query.page ? query.page : 1;
            this.setState({ queryName: "Kategori " + byCategory })
        }

        this.setState({ page: Math.ceil(query.page) })

        const content = {
            name: byName,
            minprice: byminPrice,
            maxprice: bymaxPrice,
            category: byCategory,
            sortby: bySort,
            page: page
        }

        this.fetchProductIdea(content,sortby); //panggil API lewat fetch produk
    }


    componentDidMount() {
        this.doingSearch('lowestprice');
        this.doingSearch('mostwanted');
        this.doingSearchImprint('highestprice');
        this.doingSearchIhsan('highestprice');
        this.doingSearchInspirasi('highestprice');
        this.doingSearchIdea('highestprice');
        this.fetchSliderData('newproduct', 'newproduct');
        this.fetchSliderData('diskon', 'diskon');
        this.fetchSliderData('bestSeller', 'bestSeller');
        this.fetchSliderData('jurnal', 'newest');

        
    // Data dummy store sebelum ada API
       this.setState({
        store: [
            { desc: "Insan Pustaka Berkreasi",  link:"/product/searchimprint/?name=&page=1&sortby=newproduct", image: "https://res.cloudinary.com/dhitaaaa/image/upload/v1741333837/Insan_Pustaka_Berkreasi_1-04_ao6e6a.png", badge: "Buku Fiksi"},
               { desc : "Ihsan Pustaka Buku", link:"/product/searchihsan/?name=&page=1&sortby=newproduct", image:"https://res.cloudinary.com/dhitaaaa/image/upload/v1750734451/Asset_2_von7mm.png", badge: "Buku Anak"},
            { desc : "Inspirasi Penulis Buku", link:"/product/searchinspirasi/?name=&page=1&sortby=newproduct", image:"https://res.cloudinary.com/dhitaaaa/image/upload/v1753409114/LOGO_INSPIRASI_PENULIS_BUKU_2-04_l67tbv.png", badge: "Buku Non Fiksi"},
            { desc: "Idea Publisher Book ",  link:"/product/searchidea/?name=&page=1&sortby=newproduct", image: "https://res.cloudinary.com/dhitaaaa/image/upload/v1786517787/LOGO_IDEA_300x_drwa5j.png", badge: "Buku Populer"},
            { desc: "IPB Printing", link:"https://www.ipbprinting.id/c/percetakan", image: "https://res.cloudinary.com/dhitaaaa/image/upload/v1741812953/percetakan_lkrt3t.png", badge: "Percetakan"},
            { desc: "IPBDigistore", link:"https://ipbpressdigistore.com", image: "https://res.cloudinary.com/dhitaaaa/image/upload/v1741812948/digistore_mg482m.png", badge: "Ebook"}
           
        ]
    });
    

    }

    render() {
        const { showModal } = this.state;

        let modalWarning = null;
        if (showModal) {
        modalWarning = (
            <div className="modal-overlay">
            <div className="modal-box">
                <button className="modal-close" onClick={this.handleCloseModal}>×</button>
                <h3>Website khusus e-Book IPB Press</h3>
                <p>Yakin ingin melanjutkan?</p>
                <button className="modal-confirm" onClick={this.handleConfirmRedirect}>
                Ya, Saya Yakin
                </button>
            </div>
            </div>
        );
        }
        

        return (
            <div className='bg-gray-100 min-h-screen'>
                {modalWarning}
                <SliderFront />
                <div className="store">
                <h2>More from IPB Press</h2>
                <div className="store-container">
                    {this.state.store.map((store, index) => {
                        const isDigistore = store.link === "https://ipbpressdigistore.com";
                        const storeKey = store.desc.toLowerCase().split(' ')[0];

                        // SEMUA STORE YANG PUNYA DATA BADGE AKAN MENAMPILKAN BADGE
                        const hasBadge = !!store.badge;

                        const boxClass = `store-box store-${storeKey} ${hasBadge ? 'has-badge' : ''}`;
                        const iconClass = `icon-${storeKey}`;

                        const content = (
                            <div className={iconClass}>
                                
                                {/* Logo */}
                                <img 
                                    src={store.image} 
                                    alt={store.desc} 
                                    className="store-image" 
                                />

                                {/* Judul */}
                                <p>{store.desc}</p>

                                {/* Badge */}
                                {hasBadge && (
                                    <div className="store-badge">
                                        <span>{store.badge}</span>
                                    </div>
                                )}

                            </div>
                        );

                        return isDigistore ? (
                            <button
                                key={index}
                                onClick={() => this.handleStoreClick(store.link)}
                                className={boxClass}
                            >
                                {content}
                            </button>
                        ) : (
                            <a
                                key={index}
                                href={store.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={boxClass}
                            >
                                {content}
                            </a>
                        );
                    })} 
                </div>
                </div>
            <div className="slider">
                <ProductSlider
                    title="Koleksi Terbaru"
                    category="baru"
                    products={this.state.newproduct}
                    // products={this.state.productSliderNew}
                    hyperlink="/product/newproduct/?name=&page=1&sortby=newproduct"
                    //thumbnail="https://res.cloudinary.com/blst/image/upload/v1654139568/buku-buku-terbaru.jpg"
                />
                <ProductSlider
                    title="Harga Spesial!" 
                    category="diskon"    
                    products={this.state.diskon}
                    // products={this.state.productSliderDiskon}
                    hyperlink="/product/search/?name=&page=1&sortby=diskon"
                    //thumbnail="https://res.cloudinary.com/blst/image/upload/v1654139569/buku-buku-diskon.jpg"
                />
                <ProductSlider
                    title="Best Seller!"
                    category="laris"
                    products={this.state.bestSeller}
                    // products={this.state.productSliderBestSeller}
                    hyperlink="/product/search/?name=&page=1&sortby=bestSeller"
                    //thumbnail="https://res.cloudinary.com/blst/image/upload/v1551935149/slider/buku-terlaris-ipbpress.jpg"
                />
                 <ProductSlider
                    title="Katalog Jurnal"
                    category="jurnal"
                    products={this.state.newest}
                    hyperlink="/product/jurnalproduct/?name=&page=1&sortby=newproduct"
                    //thumbnail="https://res.cloudinary.com/blst/image/upload/v1685345491/SideBar_Jurnal_5_.png"
                />
                </div>


            </div>
        )
    }
}

export default FrontPage;